// Build a flat searchable index from the live CMS content (client-side, zero extra API cost).
// Any future content added in the Admin is included automatically.
const norm = (s) => (s || "").toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

const visible = (it) => !["hidden", "archived"].includes(it?.status || "published");

export const buildSearchIndex = (content = {}) => {
  const idx = [];
  const push = (e) => { if (e.title) idx.push(e); };

  (content.realisations || []).filter(visible).forEach((p) =>
    push({ type: "Réalisation", title: p.title, subtitle: p.cat, text: `${p.synopsis || ""} ${p.description || ""}`, href: `/projet/${p.slug}`, image: p.img || p.gallery?.[0] }));

  (content.formations?.items || []).filter(visible).forEach((f) =>
    push({ type: "Formation", title: f.title, subtitle: f.level, text: `${f.description || ""} ${f.presentation || ""}`, href: `/formation/${f.slug || f.id}`, image: f.image }));

  (content.news?.items || []).filter(visible).forEach((n) =>
    push({ type: n.category || "Actualité", title: n.title, subtitle: n.date, text: `${n.excerpt || ""} ${n.content || ""}`, href: `/actualites/${n.id}`, image: n.image || n.gallery?.[0] }));

  (content.videos?.items || []).filter(visible).forEach((v) =>
    push({ type: v.category || "Vidéo", title: v.title, subtitle: "Vidéo", text: v.description, href: "/videos", image: v.thumbnail }));

  (content.events?.items || []).filter(visible).forEach((e) =>
    push({ type: e.type || "Événement", title: e.title, subtitle: e.date, text: `${e.description || ""} ${e.location || ""}`, href: "/calendrier", image: null }));

  (content.festivalArchive?.editions || []).forEach((ed) =>
    push({ type: "Festival", title: ed.title || `Édition ${ed.year}`, subtitle: ed.year, text: `${ed.description || ""} ${ed.palmares || ""}`, href: "/festival", image: ed.poster }));

  (content.pages || content.customPages || []).forEach((pg) =>
    push({ type: "Page", title: pg.title, subtitle: "Page", text: JSON.stringify(pg.blocks || pg.sections || ""), href: `/p/${pg.slug}`, image: null }));

  const f = content.festival;
  if (f) push({ type: "Festival", title: `${f.titlePrefix || "Karams"} ${f.titleAccent || "Festival"}`.trim(), subtitle: f.edition, text: `${f.description || ""} ${f.theme || ""}`, href: "/festival", image: f.backgroundImage });

  return idx;
};

// Relevance: exact title (0) > title startsWith (1) > title includes (2) > text includes (3).
export const searchContent = (index = [], query = "") => {
  const q = norm(query).trim();
  if (!q) return [];
  const scored = [];
  for (const e of index) {
    const t = norm(e.title), sub = norm(e.subtitle), txt = norm(e.text);
    let score = null;
    if (t === q) score = 0;
    else if (t.startsWith(q)) score = 1;
    else if (t.includes(q)) score = 2;
    else if (sub.includes(q)) score = 3;
    else if (txt.includes(q)) score = 4;
    if (score !== null) scored.push({ ...e, _score: score });
  }
  return scored.sort((a, b) => a._score - b._score || a.title.localeCompare(b.title)).slice(0, 30);
};
